import React from 'react';
import UserProfile from "./UserProfile";
import UserNotification from "./userNotification";
import MapSetting from "./MapSetting";

const HeaderRight = () => {
    return (
        <div className="header-right">
            <MapSetting/>
            <UserNotification/>
            <UserProfile/>
        </div>
    );
};

export default HeaderRight;

